import React from 'react';
import PropTypes from 'prop-types';
import {
  FieldArray,
} from 'react-final-form-arrays';
import {
  FormattedMessage,
} from 'react-intl';

import {
  Accordion,
} from '@folio/stripes/components';

import {
  RECORD_LINK_FIELDS,
  RECORD_LINKAGE,
  RECORD_LINKAGE_PAGE_TYPES,
  UPDATE_STATUS,
  NAME_LIMIT_MAX,
  URL_LIMIT_MAX,
} from '../../../../constants';
import {
  AddRecordLinkageButton,
  RecordLinkageRow,
  RecordLinkageTitle,
} from './components';
import {
  composeValidators,
  validateFieldLength,
  validateRequiredField,
  validateUniqueField,
  validateUrl as validateUrlValidator,
} from '../../../../utils';

const shouldShowRecordLinkage = (fields) => (
  fields?.value
    ? fields.value.filter((record) => (
      record[RECORD_LINK_FIELDS.UPDATE_STATUS] !== UPDATE_STATUS.DELETE
    )).length
    : false
);

const validateNameLength = (value) => validateFieldLength(value, NAME_LIMIT_MAX);

const validateUrlLength = (value) => validateFieldLength(value, URL_LIMIT_MAX);

const validate = (values) => {
  const errorArray = [];

  if (values) {
    values.forEach((value) => {
      const name = value[RECORD_LINK_FIELDS.NAME];
      const url = value[RECORD_LINK_FIELDS.URL];
      const updateStatus = value[RECORD_LINK_FIELDS.UPDATE_STATUS];
      const errors = {};

      if (updateStatus !== UPDATE_STATUS.DELETE) {
        errors[RECORD_LINK_FIELDS.NAME] = composeValidators(
          validateUniqueField(values, RECORD_LINK_FIELDS.NAME),
          validateRequiredField,
          validateNameLength,
        )(name);

        errors[RECORD_LINK_FIELDS.URL] = composeValidators(
          validateRequiredField,
          validateUrlValidator,
          validateUrlLength,
        )(url);
      }

      errorArray.push(errors);
    });
  }

  return errorArray;
};

const RecordLinkageEdit = ({
  pageType,
}) => {
  return (
    <div data-test-record-linkage-edit>
      <Accordion
        id={RECORD_LINKAGE}
        label={<FormattedMessage id="ui-task-list.title.accordion.recordLinkage" />}
      >
        <FieldArray
          name={RECORD_LINKAGE}
          validate={validate}
        >
          {
            ({ fields }) => (shouldShowRecordLinkage(fields)
              ? (
                <>
                  <RecordLinkageTitle />
                  {
                    fields.map((link, index) => (
                      <RecordLinkageRow
                        key={index}
                        fields={fields}
                        index={index}
                        link={link}
                      />
                    ))
                  }
                </>
              )
              : (
                <AddRecordLinkageButton
                  fields={fields}
                  pageType={pageType}
                />
              ))
          }
        </FieldArray>
      </Accordion>
    </div>
  );
};

RecordLinkageEdit.propTypes = {
  pageType: PropTypes.oneOf(RECORD_LINKAGE_PAGE_TYPES).isRequired,
};

export default RecordLinkageEdit;
